import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mx-auto text-center" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-grow text-warning",
  role: "status"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}